<template>
    <div
        :class="[
            'custom-swiper-container',
            {
                pc: isPc
            }
        ]"
        :style="[cssProperties]"
    >
        <div class="swiper custom-swiper" ref="swiper">
            <div class="swiper-wrapper">
                <div v-for="(slide, i) in slides" class="swiper-slide">
                    <div class="swiper-item" :style="swiperBodyStyle(slide)">
                        <renderer :key="slide.id" :tpl="slide" :style="setStyle(slide)"></renderer>
                    </div>
                </div>
            </div>
            <div v-show="!isPreRender" class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>
const {
    library: { ramda },
    renderer,
    store: { variable }
} = window.FEGORender;
const {
    state: { initCmpStateMatchine }
} = window.FEGOBridge;
import Core from './core.vue';
export default {
    mixins: [Core],
    data() {
        return {
            isPreRender: FEGORender.common.env.isPreRender,
        };
    },
    props: {},
    components: {
        renderer
    },
    computed: {
        slides() {
            const { children = [] } = this.tpl;
            return children.map((child) => ramda.mergeDeepRight(child, initCmpStateMatchine(child, variable.data)));
        }
    },
    watch: {},
    methods: {},
    mounted() {
        !this.isPreRender && this.$nextTick(this.initSwiper);
    }
};
</script>
<style lang="less" scoped>
@import '../render/index.less';
</style>
